import React from 'react';
import EChartsReact from 'echarts-for-react';
import { generateColors, getValueFromPercent } from 'utils/helpers';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
    layout?: 'horizontal' | 'vertical';
}

const QuestionBarMultiLine: React.FC<Props> = ({
    data,
    layout = 'horizontal',
}) => {
    const isHorizontal = layout === 'horizontal';
    const categories = data?.category?.map((item: string) => item);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const series = data?.value?.map((item: any, index: number) => {
        const colors = generateColors(data.length || 1);
        return {
            name: item?.name,
            type: 'bar',
            data: item?.value?.map((val: number, i: number) => ({
                name: data?.label?.[i] ?? `Item ${i + 1}`,
                value: val ?? 0,
                total: item?.total?.[i] ?? 0,
            })),
            barWidth: 'auto',
            barMinWidth: 5,
            barMaxWidth: 50,
            label: {
                show: true,
                position: isHorizontal ? 'right' : 'top',
                formatter: (params: { value: number }) => {
                    const value = params.value;
                    return `${value}%`;
                },
            },
            itemStyle: {
                color: colors[index],
            },
        };
    });
    const option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            formatter: function (params: any) {
                let tooltipContent = `<strong>${params[0].axisValue}</strong><br/>`; // Hiển thị giá trị trục X
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                params.forEach((item: any) => {
                    tooltipContent += `
                                            <span style="display:inline-block;width:10px;height:10px;
                                            background-color:${item.color};border-radius:50%;margin-right:5px;"></span>${item.seriesName}:
                                            <strong>${getValueFromPercent(item.value, item.data.total, 0)}</strong><br/>`;
                });

                return tooltipContent;
            },
        },
        legend: {
            top: 10,
            type: 'scroll',
            icon: 'circle',
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
        },
        xAxis: isHorizontal
            ? { type: 'value' }
            : { type: 'category', data: categories },
        yAxis: isHorizontal
            ? { type: 'category', data: categories }
            : { type: 'value' },
        series: series,
    };

    return <EChartsReact style={{ height: 500 }} option={option} />;
};

export default QuestionBarMultiLine;
